import { CloseIcon, MenuIcon } from '@eventbrite/marmalade';
import React from 'react';
import {
    getHeapDataAttribute,
    HeapAttributes,
} from '../../../../../utils/heap-data';
import { DropdownContainerProps } from '../../../../types';
import { Dropdown } from '../Dropdown';
import styles from './MobileDropdown.module.scss';

const MobileDropdown = ({
    dropdownItems,
}: Omit<DropdownContainerProps, 'heapIdentifier' | 'translatedText'>) => {
    const { Teams, Features, Components, Actions } = HeapAttributes;
    return (
        <li
            data-heap-id={getHeapDataAttribute({
                team: Teams.SEO,
                feature: Features.GlobalNav,
                component: Components.Dropdown,
                name: 'mobile',
                action: Actions.Click,
            })}
            className={styles.mobileDropdown}
            tabIndex={0}
        >
            <MenuIcon size="small" />
            <CloseIcon size="small" />
            <Dropdown dropdownItems={dropdownItems} />
        </li>
    );
};

export default MobileDropdown;
